<template>
  <div class="sideMenu">
    <div class="col">
      <div class="col ">
        <div class="title bg-info bg-opacity-30 align-items-center d-flex" @click="onClickMainIndex(0)">
          <label class="fw-bold mx-2">{{ t('ADMIN_STATISTICS.SIDE_MENU[0]') }}</label>
        </div>
        <ul v-if="getShowSubContent(0)" class="list-group list-group-flush">
          <router-link :to="{name: 'statistics.allPerDay'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[0]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[0]') }}
            </li>
          </router-link>
          <router-link :to="{name: 'statistics.allPerMonth'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[1]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[0]') }}
            </li>
          </router-link>
          <router-link :to="{name: 'statistics.allPerTimeZone'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[2]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[0]') }}
            </li>
          </router-link>
        </ul>
      </div>
      <div class="col mt-1">
        <div class="title bg-info bg-opacity-30 align-items-center d-flex" @click="onClickMainIndex(1)">
          <label class="fw-bold mx-2">{{ t('ADMIN_STATISTICS.SIDE_MENU[1]') }}</label>
        </div>
        <ul v-if="getShowSubContent(1)" class="list-group list-group-flush">
          <router-link :to="{name: 'statistics.mileagePerDay'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[0]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[1]') }}
            </li>
          </router-link>
          <router-link :to="{name: 'statistics.mileagePerMonth'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[1]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[1]') }}
            </li>
          </router-link>
          <router-link :to="{name: 'statistics.mileagePerTimeZone'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[2]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[1]') }}
            </li>
          </router-link>
        </ul>
      </div>
      <div class="col mt-1">
        <div class="title bg-info bg-opacity-30 align-items-center d-flex" @click="onClickMainIndex(2)">
          <label class="fw-bold mx-2">{{ t('ADMIN_STATISTICS.SIDE_MENU[2]') }}</label>
        </div>
        <ul v-if="getShowSubContent(2)" class="list-group list-group-flush">
          <router-link :to="{name: 'statistics.warningPerDay'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[0]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[2]') }}
            </li>
          </router-link>
          <router-link :to="{name: 'statistics.warningPerMonth'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[1]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[2]') }}
            </li>
          </router-link>
          <router-link :to="{name: 'statistics.warningPerTimeZone'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[2]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[2]') }}
            </li>
          </router-link>
        </ul>
      </div>
      <div class="col mt-1">
        <div class="title bg-info bg-opacity-30 align-items-center d-flex" @click="onClickMainIndex(3)">
          <label class="fw-bold mx-2">{{ t('ADMIN_STATISTICS.SIDE_MENU[3]') }}</label>
        </div>
        <ul v-if="getShowSubContent(3)" class="list-group list-group-flush">
          <router-link :to="{name: 'statistics.overspeedPerDay'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[0]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[3]') }}
            </li>
          </router-link>
          <router-link :to="{name: 'statistics.overspeedPerMonth'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[1]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[3]') }}
            </li>
          </router-link>
          <router-link :to="{name: 'statistics.overspeedPerTimeZone'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[2]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[3]') }}
            </li>
          </router-link>
        </ul>
      </div>
      <div class="col mt-1">
        <div class="title bg-info bg-opacity-30 align-items-center d-flex" @click="onClickMainIndex(4)">
          <label class="fw-bold mx-2">{{ t('ADMIN_STATISTICS.SIDE_MENU[4]') }}</label>
        </div>
        <ul v-if="getShowSubContent(4)" class="list-group list-group-flush">
          <router-link :to="{name: 'statistics.offlinePerDay'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[0]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[4]') }}
            </li>
          </router-link>
          <router-link :to="{name: 'statistics.offlinePerMonth'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[1]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[4]') }}
            </li>
          </router-link>
          <router-link :to="{name: 'statistics.offlinePerTimeZone'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_MENU[2]') }}{{ t('ADMIN_STATISTICS.SIDE_MENU[4]') }}
            </li>
          </router-link>
        </ul>
      </div>
      <div class="col mt-1">
        <div class="title bg-info bg-opacity-30 align-items-center d-flex" @click="onClickMainIndex(5)">
          <label class="fw-bold mx-2">{{ t('ADMIN_STATISTICS.SIDE_MENU[5]') }}</label>
        </div>
        <ul v-if="getShowSubContent(5)" class="list-group list-group-flush">
          <router-link :to="{name: 'statistics.offlineDevice'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_EXTRA[0]') }}
            </li>
          </router-link>
          <router-link :to="{name: 'statistics.onlineStatus'}" custom v-slot="{navigate, isExactActive}">
            <li class="list-group-item" @click="navigate" :class="isExactActive && activeClass">
              {{ t('ADMIN_STATISTICS.SIDE_SUB_EXTRA[1]') }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { computed } from '@vue/runtime-core'
export default {
  setup () {
    const { t } = useI18n()
    const store = useStore()

    const selectMainIndex = computed(() => store.getters['adminStatistics/getSelectMainIndex'])

    const onClickMainIndex = (index) => {
      store.commit('adminStatistics/setSelectMainIndex', index)
    }
    const getShowSubContent = (index) => {
      return selectMainIndex.value === index
    }

    return {
      t,
      selectMainIndex,
      onClickMainIndex,
      getShowSubContent,
      activeClass: 'text-danger'
    }
  }
}
</script>

<style lang="stylus" scoped>
.title {
  cursor: pointer
  height: 2rem
  & label {
    cursor: pointer
  }
}
.list-group-item {
  cursor: pointer
  font-size: 1rem
}
</style>
